export enum JourneyOutcome {
  UNSPECIFIED = 'JOURNEY_OUTCOME_UNSPECIFIED',
  SUCCEEDED = 'JOURNEY_OUTCOME_SUCCEEDED',
  FAILED = 'JOURNEY_OUTCOME_FAILED',
  USER_CANCELED = 'JOURNEY_OUTCOME_USER_CANCELED',
  PROCESS_CRASHED = 'JOURNEY_OUTCOME_PROCESS_CRASHED',
  PROCESS_KILLED = 'JOURNEY_OUTCOME_PROCESS_KILLED',
  TERMINATED = 'JOURNEY_OUTCOME_TERMINATED',
}

export enum JourneyTerminationReason {
  UNSPECIFIED = 'JOURNEY_TERMINATION_REASON_UNSPECIFIED',
  TIMEOUT_WITH_ACTIVE_USER = 'JOURNEY_TERMINATION_REASON_TIMEOUT_WITH_ACTIVE_USER',
  TIMEOUT_WITH_IDLE_USER = 'JOURNEY_TERMINATION_REASON_TIMEOUT_WITH_IDLE_USER',
  JOURNEY_RESTARTED = 'JOURNEY_TERMINATION_REASON_JOURNEY_RESTARTED',
  MISSING_BLOCKER_FLOW_OUTCOME = 'JOURNEY_TERMINATION_REASON_MISSING_BLOCKER_FLOW_OUTCOME',
}

export type UserJourney = {
  id: string
  name: string
  created: number
  variant?: string
  frustrations: string[]
  frictions: string[]
  tags: string[]
}

export type UserJourneyState = {
  history: string[]
  journeys: Record<string, UserJourney>
  active?: string
}

export type UserJourneyAction =
  | {
      type: 'USER_JOURNEY_START'
      id: string
      name: string
      created?: number
    }
  | {
      type: 'USER_JOURNEY_RESUME'
      name: string
      journey: UserJourney
      esid: string
    }
  | {
      type: 'USER_JOURNEY_COMPLETE'
      name: string
      outcome: JourneyOutcome
      terminationReason?: JourneyTerminationReason
    }
  | {
      type: 'USER_JOURNEY_ADD_FRUSTRATION'
      name: string
      frustration: string
    }
  | {
      type: 'USER_JOURNEY_ADD_FRICTION'
      name: string
      friction: string
    }
  | {
      type: 'USER_JOURNEY_ADD_TAG'
      name: string
      tag: string
    }
  | {
      type: 'USER_JOURNEY_SET_VARIANT'
      name: string
      variant: string | undefined
    }

export type UserJourneyStateChange = {
  action: UserJourneyAction
  prevState: UserJourneyState
  state: UserJourneyState
}

export type UserJourneyListener = (change: UserJourneyStateChange) => void

export type UserJourneyContextProps = {
  enabled: boolean
  startJourney: (name: string, created?: number, id?: string) => void
  resumeJourney: (journey: UserJourney, esid: string) => void
  completeJourney: {
    (name: string, outcome: Exclude<JourneyOutcome, JourneyOutcome.TERMINATED>): void
    (name: string, outcome: JourneyOutcome.TERMINATED, terminationReason: JourneyTerminationReason): void
  }
  addFrustration: (name: string, frustration: string) => void
  addFriction: (name: string, friction: string) => void
  addTag: (name: string, tag: string) => void
  setVariant: (name: string, variant: string | undefined) => void
  getActiveJourney: () => UserJourney | undefined
  subscribe: (listener: UserJourneyListener) => () => void
  active?: UserJourney
  history?: UserJourney[]
}
